import script from "./BrockerpurchaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BrockerpurchaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./BrockerpurchaseDetail.vue?vue&type=style&index=0&id=c0c33e12&scoped=true&lang=css"
import "./BrockerpurchaseDetail.vue?vue&type=style&index=1&id=c0c33e12&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c33e12"]])

export default __exports__